import { getCurrentInstance as q, inject as w, ref as v, watch as g, unref as i } from "vue";
import k from "./index592.js";
import { getDefaultValue as A, isValidRange as J } from "./index862.js";
import { ROOT_PICKER_INJECTION_KEY as L } from "./index632.js";
import { useShortcut as Y } from "./index936.js";
import { useNamespace as z } from "./index559.js";
import { useLocale as B } from "./index597.js";
import { isArray as D } from "./index575.js";
import F from "./index712.js";
const V = (r, {
  defaultValue: h,
  defaultTime: C,
  leftDate: p,
  rightDate: N,
  step: O,
  unit: R,
  sortDates: E
}) => {
  const { emit: _ } = q(), { pickerNs: I } = w(L), P = z("date-range-picker"), { t: b, lang: f } = B(), x = Y(f), a = v(), s = v(), l = v({
    endDate: null,
    selecting: !1
  }), T = (t) => {
    l.value = t;
  }, j = (t = !1) => {
    const e = i(a), n = i(s);
    J([e, n]) && _("pick", [e, n], t);
  }, y = (t) => {
    l.value.selecting = t, t || (l.value.endDate = null);
  }, u = (t) => {
    if (D(t) && t.length === 2) {
      const [e, n] = t;
      a.value = e, p.value = e, s.value = n, E(i(a), i(s));
    } else
      S();
  }, S = () => {
    let [t, e] = A(i(h), {
      lang: i(f),
      step: O,
      unit: R,
      unlinkPanels: r.unlinkPanels
    });
    const n = (o) => o.diff(o.startOf("d"), "ms"), m = i(C);
    if (m) {
      let o = 0, d = 0;
      if (D(m)) {
        const [c, K] = m.map(k);
        o = n(c), d = n(K);
      } else {
        const c = n(k(m));
        o = c, d = c;
      }
      t = t.startOf("d").add(o, "ms"), e = e.startOf("d").add(d, "ms");
    }
    a.value = void 0, s.value = void 0, p.value = t, N.value = e;
  };
  return g(
    h,
    (t) => {
      t && S();
    },
    { immediate: !0 }
  ), g(
    () => r.parsedValue,
    (t) => {
      (!t?.length || !F(t, [a.value, s.value])) && u(t);
    },
    {
      immediate: !0
    }
  ), g(
    () => r.visible,
    () => {
      r.visible && u(r.parsedValue);
    },
    { immediate: !0 }
  ), {
    minDate: a,
    maxDate: s,
    rangeState: l,
    lang: f,
    ppNs: I,
    drpNs: P,
    handleChangeRange: T,
    handleRangeConfirm: j,
    handleShortcutClick: x,
    onSelect: y,
    parseValue: u,
    t: b
  };
};
export {
  V as useRangePicker
};
